import { Trip } from './../classes.js';
import { notification } from './../function/notification.js';

export class cPublish {
	constructor() {
		
		$('body').on('click', '.publish--open', {obj: this}, function(e){
			e.preventDefault();
			
			//load the display
			e.data.obj.open();
		})
		
		$('body').on('click', '.publish--close', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.close();
		})
		
		$('body').on('click', '#publish', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.publish();
		});
		
	}
	
	
	open(){
		Trip.save();
		$('#publish').css("display", "flex").hide().fadeIn(200);
		this.set_publish();
	}
	
	
	close(){
		//close the display
		$('#publish').fadeOut(200);
	}
	
	
	set_publish(){
		//set vars for this click event
		this.trip_id = $('#trip_id').val();
	}
	
	
	async publish(){
		//create the form to upload a file
		let pub = new FormData(document.querySelector('#form__pub'));
		let tf = document.querySelector('.form.trip__body');
		let pub_form = new FormData(tf);
		
		//add the trip_id of our current focus
		pub_form.append('trip_id', this.trip_id);
		pub_form.append('trip_price', pub.get('trip_price'));
		pub_form.append('trip_confirm', pub.get('trip_confirm'));
		
		try {
			let response = await fetch('/api/trip/publish', {
				method: 'POST',
				body: pub_form
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			let result = await response.json();
			
			if(result.error){
				//error
				console.log(result);
			}else{
				this.close();
				notification('Published');
				window.location.href = "/u/creator-dashboard";
			}
			
		} catch (error) {
			console.error('Error ***', error);
		}
	}
	
	
}